export default __webpack_public_path__ + "static/media/logo-picnic.56de0484.svg";